import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import TestimonialCard from "./TestimonialCard";

const Testimonials = ({ testimonials = [] }) => {
  if (!testimonials.length) {
    return null;
  }

  const isFewTestimonials = testimonials.length <= 2;

  return (
    <section className="py-16 md:py-20 bg-[#FAF9F6] overflow-hidden">
      <div className="w-full">

        {/* Heading */}
        <div className="text-center mb-12 md:mb-16 px-5">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-[#2F2F2F]">
            Hear It From Our Clients
          </h2>

          <p className="text-sm md:text-base text-[#7A7A7A] mt-4">
            Hear from the brands and partners who have trusted us to bring their ideas to life.
          </p>
        </div>

        {/* 1–2 testimonials */}
        {isFewTestimonials ? (
          <div className="flex justify-center gap-6 px-5">
            {testimonials.map((item) => (
              <div
                key={item.id}
                className="w-full max-w-[337px]"
              >
                <TestimonialCard item={item} />
              </div>
            ))}
          </div>
        ) : (

          /* 3+ testimonials */
          <div className="relative">
            <Swiper
              modules={[Pagination, Autoplay]}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              pagination={{
                clickable: true,
              }}
              loop={testimonials.length > 3}
              centeredSlides={true}
              slidesPerView="auto"
              spaceBetween={30}
              className="!pb-14 !overflow-visible"
            >
              {testimonials.map((item) => (
                <SwiperSlide
                  key={item.id}
                  className="!w-[337px] !h-auto"
                >
                  <TestimonialCard item={item} />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Left gradient */}
            <div
              className="
                pointer-events-none
                absolute
                left-0
                top-0
                bottom-14
                w-16
                md:w-24
                lg:w-32
                z-10
                bg-gradient-to-r
                from-[#FAF9F6]
                to-transparent
              "
            />

            {/* Right gradient */}
            <div
              className="
                pointer-events-none
                absolute
                right-0
                top-0
                bottom-14
                w-16
                md:w-24
                lg:w-32
                z-10
                bg-gradient-to-l
                from-[#FAF9F6]
                to-transparent
              "
            />
          </div>
        )}

      </div>
    </section>
  );
};

export default Testimonials;